import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    addTaskModalVisible: false
}

export const AddTaskSlice = createSlice({
  name: 'addTask',
  initialState,
  reducers: {
    showAddTaskModal: (state, action) => {
      const {
        addTaskModalVisible
      } = action.payload
      state.addTaskModalVisible = addTaskModalVisible
    },
    hideAddTaskModal: (state, action) => {
        state.addTaskModalVisible = false
      }
  }
})

export const { showAddTaskModal, hideAddTaskModal } = AddTaskSlice.actions;


export default AddTaskSlice.reducer
